import React, { useEffect, useRef, useState } from 'react'
import Login from '../../UI/Cards/FormCard/Login';
import Verification from '../../UI/Cards/FormCard/Verification';
import Register from '../../UI/Cards/FormCard/Register';

import FormCard from '../../UI/Cards/FormCard/FormCard/FormCard';

// import loginImage from "../../../assets/LoginImage.png";
import loginImage from "../../../assets/Portal Login Image/LoginImage.jpeg";


import classes from "./LoginV2.module.css";
import Modal from '../../Modal/Modal';
import SetTag from '../../Modal/ModalLayouts/SetTag';
import InputForm from '../../forms/InputForm';
import { useDispatch, useSelector } from 'react-redux';

import { resetPortalPassword } from "../../../Api Methods/Api"
import { authActions } from '../../../store/auth-Slice';
import ResetPortalPasswordForm from '../../forms/ResetPortalPasswordForm';
import SimpleSingleInputForm from '../../forms/SimpleSingleInputForm';
import { useNavigate } from "react-router-dom";
import { uiActions } from '../../../store/ui-slice';
import Lottie from 'lottie-react'
import successAnim from '../../../assets/animations/success.json'
import failAnim from '../../../assets/animations/fail.json'
import Button1 from '../../UI/Button/Button1';
import mixpanel from 'mixpanel-browser';
import { Button } from 'primereact/button';

const LoginPage = () => {


    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();
    const ModalDialogPopup = useRef();
    const [modalComponent, setModalComponent] = useState()
    const [title, setTitle] = useState("")

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const HandleShowPopupModal = () => {
        ModalDialogPopup.current.open();
    }

    const HandleClosePopupModal = () => {
        ModalDialogPopup.current.close();
    }



    //---------------------------------------------------------------------------------------------

    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);

    const apiData = {
        token,
        client
    }

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleOnFormSuccess = async (email) => {
        const response = await resetPortalPassword(apiData, email, dispatch)
        if (response.data.success) {
            HandleCloseModal();
            setTitle("Success")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>We've sent you an email with instructions on how to reset your password</h3>
                    <br></br>
                    <Button severity='secondary' onClick={HandleClosePopupModal} label="Close"/>
                </div>
            )
            HandleShowPopupModal()

        } else {
            HandleCloseModal()
            setTitle("Error")
            //attempted password, failed
            mixpanel.track(
                "Attempted password reset",{
                    user: email
                }
            )
            
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>We're having trouble finding an authorised portal account with that email address, please contact your administrator</h3>
                    <br></br>
                    <Button onClick={HandleClosePopupModal} label='Close' severity='secondary'/>
                </div>
            )

            HandleShowPopupModal();
        }
    }

    return (
        <>

            <Modal ref={ModalDialogPopup} title={title} modalName={"Login"} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <Modal ref={ModalDialog} title={"Reset password"} modalName={"Login"} HandleShowModal={HandleShowModal}>
                <SimpleSingleInputForm isInputEmail={true} placeholder={"Please enter your email address"} submitButtonText={"Reset password"} handleOnFormSuccess={handleOnFormSuccess} />
            </Modal>

            <div className={classes["page-layout"]}>

                <div className={classes.container} >
                    <img className={classes.imageContainer} src={loginImage} loading={'eager'} />

                    <Login className={classes.card} formType="emailPassword" HandleShowModal={HandleShowModal} extraLinks={[{ LinkTextBold: "Activate account", to: "/Register" }]} />
                </div>


            </div>
        </>
    )
}

export default LoginPage